import styled from "styled-components";
import {DialogTextBox} from "../../modal-dialog/boxes/text/dialog-text.box";

export const LoginPopupDialogText = styled(DialogTextBox)`
    margin: 0;
`;